<div class="document-list-container">
  <div *ngIf="loading" class="loading-container">
    <app-loading-spinner></app-loading-spinner>
  </div>

  <div *ngIf="!loading && uiMetadata && computedDisplayedColumns.length > 0 && dataSource">
    <table mat-table
           class="ecase-mat-table resutTextStyle document-list-table"
           [dataSource]="dataSource"
           matSort
           [matSortActive]="sortActive"
           [matSortDirection]="sortDirection"
           (matSortChange)="sortColumn($event)">

      <ng-container *ngFor="let column of computedDisplayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column" [disabled]="column === 'actions'">
          <ng-container *ngIf="column !== 'actions'">
            <u>{{ getColumnHeader(column) }}</u>
          </ng-container>
          <ng-container *ngIf="column === 'actions'">
            <span class="nodisplay">.</span>
          </ng-container>
        </th>

        <td mat-cell *matCellDef="let row" class="tdStyle">
          <ng-container [ngSwitch]="column">
            <ng-container *ngSwitchCase="'actions'">
              <button *ngIf="shouldShowActions(row)"
                      [matMenuTriggerFor]="actionMenu"
                      (click)="$event.stopPropagation()"
                      [attr.aria-label]="'ecase.explorer.documentList.moreActions' | translate"
                      class="mat-icon-button eCase-in-table-mat-button">
                <mat-icon>more_vert</mat-icon>
                <span>{{ 'ecase.explorer.documentList.actions' | translate }}</span>
              </button>
              <mat-menu #actionMenu="matMenu">
                <ng-container *ngFor="let action of getVisibleActionsForRow(row)">
                  <button (click)="handleAction(row, action); $event.stopPropagation()"
                          mat-menu-item>
                    {{ getActionLabel(action) }}
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>

            <ng-container *ngSwitchCase="'documentName'">
              <a *ngIf="isDownloadAvailable(row)"
                 (click)="openDocument(row); $event.stopPropagation()"
                 class="text-wrap-link"
                 [title]="getCellValue(row, column)">
                {{ getCellValue(row, column) }}
              </a>
              <span *ngIf="!isDownloadAvailable(row)" class="text-wrap">
                {{ getCellValue(row, column) }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'fileName'">
              <a *ngIf="isDownloadAvailable(row)"
                 (click)="openDocument(row); $event.stopPropagation()"
                 class="text-wrap-link"
                 [title]="getCellValue(row, column)">
                {{ getCellValue(row, column) }}
              </a>
              <span *ngIf="!isDownloadAvailable(row)" class="text-wrap">
                {{ getCellValue(row, column) }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'approvals'">
              <div style="padding: 5px" *ngIf="row.isDocumentApprovalRequired">
                <span *ngIf="row.isDocumentApprovalProcessed === -2">
                  {{'ecase.admindashboard.eligibility.awf.AWFDocument.approval.notstarted' | eCaseTranslate}}
                </span>
                <a *ngIf="row.isDocumentApprovalProcessed !== -2"
                   (click)="openDocumentApprovalPopUp(row); $event.preventDefault(); $event.stopPropagation()"
                   style="cursor: pointer; text-decoration: underline;">
                  <span *ngIf="row.isDocumentApprovalProcessed === 0">
                    {{'ecase.admindashboard.eligibility.awf.AWFDocument.approval.inprogress' | eCaseTranslate}}
                  </span>
                  <span *ngIf="row.isDocumentApprovalProcessed === 1">
                    {{'ecase.admindashboard.eligibility.awf.AWFDocument.approval.completed' | eCaseTranslate}}
                    ({{row.isDocumentApproved === 0 ? ('ecase.admindashboard.eligibility.awf.AWFDocument.approval.rejected' | eCaseTranslate)
                    : ('ecase.admindashboard.eligibility.awf.AWFDocument.approval.approved' | eCaseTranslate)}})
                  </span>
                </a>
              </div>
              <span style="padding: 5px" *ngIf="!row.isDocumentApprovalRequired">
                {{'ecase.admindashboard.eligibility.awf.AWFDocument.approval.notrequired' | eCaseTranslate}}
              </span>
            </ng-container>

            <span *ngSwitchDefault>
              {{ getCellValue(row, column) }}
            </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of computedDisplayedColumns; let i = index"
                    [matColumnDef]="'header-row-' + i + '-group'">
        <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
          <span class="nodisplay">.</span>

          <ng-container *ngIf="column === 'actions'">
            <div class="filter-button-container">
              <button class="eCase-dialog-positive-action-button"
                      mat-raised-button
                      (click)="applyFilter()"
                      *ngIf="uiMetadata?.filteredColumns && uiMetadata.filteredColumns.length > 0">
                {{ 'ecase.common.filter' | translate }}
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="i === 0 && column !== 'actions' && uiMetadata?.filteredColumns?.length > 0">
            <div class="first-filter-cell-container">
              <div class="filter-icon-container">
                <input *ngIf="showImage" alt="clear" class="row_filter_icon"
                       disabled matRipple
                       src="../../../../assets/images/etc/icons8-conversion.svg" type="image">
                <input (click)="clearFilter()" *ngIf="!showImage" alt="clear"
                       class="row_filter_icon" src="../../../../assets/images/etc/icons8-clear-filters.svg"
                       type="image">
              </div>
              <select *ngIf="uiMetadata?.filteredColumns?.includes(column) && column === 'isArchived'"
                      class="searchFields"
                      [attr.aria-label]="getColumnHeader(column)"
                      [(ngModel)]="filterObject[column]"
                      [ngModelOptions]="{standalone: true}">
                <option value="">{{ 'ecase.explorer.documentList.all' | translate }}</option>
                <option value="true">{{ 'ecase.explorer.documentList.yes' | translate }}</option>
                <option value="false">{{ 'ecase.explorer.documentList.no' | translate }}</option>
              </select>
              <input *ngIf="uiMetadata?.filteredColumns?.includes(column) && column !== 'isArchived'"
                     type="text" class="searchFields"
                     [attr.aria-label]="getColumnHeader(column)"
                     [(ngModel)]="filterObject[column]"
                     [placeholder]="'ecase.explorer.search.search' | eCaseTranslate"
                     [ngModelOptions]="{standalone: true}">
            </div>
          </ng-container>

          <ng-container *ngIf="i !== 0 && column !== 'actions' && uiMetadata?.filteredColumns?.includes(column)">
            <select *ngIf="column === 'isArchived'"
                    class="searchFields"
                    [attr.aria-label]="getColumnHeader(column)"
                    [(ngModel)]="filterObject[column]"
                    [ngModelOptions]="{standalone: true}">
              <option value="">{{ 'ecase.explorer.documentList.all' | translate }}</option>
              <option value="true">{{ 'ecase.explorer.documentList.yes' | translate }}</option>
              <option value="false">{{ 'ecase.explorer.documentList.no' | translate }}</option>
            </select>
            <input *ngIf="column !== 'isArchived'"
                   type="text" class="searchFields"
                   [attr.aria-label]="getColumnHeader(column)"
                   [(ngModel)]="filterObject[column]"
                   [placeholder]="'ecase.explorer.search.search' | eCaseTranslate"
                   [ngModelOptions]="{standalone: true}">
          </ng-container>
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="computedDisplayedColumns"></tr>

      <ng-container *ngIf="uiMetadata?.filteredColumns && uiMetadata.filteredColumns.length > 0">
        <tr mat-header-row *matHeaderRowDef="getFilterRowColumns()"></tr>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: computedDisplayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="computedDisplayedColumns.length">
          <div class="empty-state">
            <p>{{ 'ecase.explorer.documentList.noDocumentsAvailable' | translate }}</p>
          </div>
        </td>
      </tr>
    </table>

    <span>{{ totalCount }} {{ 'ecase.explorer.search.results' | eCaseTranslate }}</span>

    <mat-paginator *ngIf="totalCount"
                   [pageSize]="pageSize"
                   [pageIndex]="pageIndex"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="onPaginationChange($event)"
                   [length]="totalCount"
                   showFirstLastButtons></mat-paginator>
  </div>

  <div *ngIf="!loading && (!uiMetadata || computedDisplayedColumns.length === 0)" class="error-state">
    <p>{{ 'ecase.explorer.documentList.configMissing' | translate }}</p>
  </div>
</div>
